<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" href="#tabs-2-tab-1" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Grupo Campos
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show" id="tabs-2-tab-1">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 40%">Código</th>
                                    <th style="width: 10%">Descrição</th>
                                    <th style="width: 10%">Coluna</th>
                                    <th style="width: 10%">Status</th>
                                    <th style="width: 10%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.b_grupo_dados_campo">
                                    <td>
                                        {{ item.cd }}
                                    </td>
                                    <td>
                                        {{ item.descr }}
                                    </td>
                                    <td>
                                        {{ item.coluna }}
                                    </td>
                                    <td>
                                    <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                    <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                  </td>
                                  <td>
                                      <a v-if="item.status.valor==2" @click="onActivateDesactivate(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                      <a v-if="item.status.valor==1" @click="onActivateDesactivate(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                      <a @click="onEditCampo(item)" v-b-tooltip title="Editar Grupo"><i class="fa fa-edit"></i></a>
                                  </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
            <BGrupoDadosCampoForm
                ref="bgrupodadoscampoform" :metodo="onFilterReset" :tabela="'b_grupo_dados_campo'" :rota="'bgrupodadoscampo'">
            </BGrupoDadosCampoForm>
		</div>
    </div>
  </template>

  <script>
  import BGrupoDadosCampoForm from './BGrupoDadosCampoForm'
  export default {
      components: {
          BGrupoDadosCampoForm
      },
      data () {
        return {
          helpForm: new Form({recordCollection: [], status: ''}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onEditCampo(data) {
            this.$refs.bgrupodadoscampoform.onEdit(data);
        },
        onActivateDesactivate(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.recordCollection = [];
                this.helpForm.recordCollection.push(data.bgrpdadc_id );
            }
            else
            {
                this.helpForm.recordCollection = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.recordCollection.push(obj)
                });
            }
            this.helpForm.patch('/api/bgrupodadoscampo/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
  }
}
  </script>
